/* eslint-disable import/prefer-default-export */
import axios from 'axios';

// Returns a site_config value
export function loadConfig(key, useDataSite = false, access = 'agent') {
  const token = localStorage.getItem('SessionToken');
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/name/`,
      params: { name: key, access, use_data_site: useDataSite },
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      resolve(data);
    }).catch((err) => {
      if (err.response.status === 404) {
        console.warn(`site_config '${key}' does not exist or does not have the proper permission level`);
      }
      reject(err);
    });
  });
}

export function loadConfigs(category, site = 'ALL_SITES_SITE', access = 'public') {
  const token = localStorage.getItem('SessionToken');
  return axios({
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/name/`,
    params: { name: category, site, access },
  }).then((res) => res.data);
}
